var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4115 12.5003L18.6886 17.7822C19.079 18.1729 19.0787 18.806 18.688 19.1964C18.2973 19.5867 17.6641 19.5864 17.2738 19.1957L11.9963 13.9135L6.70658 19.1953C6.31577 19.5856 5.6826 19.5851 5.29237 19.1943C4.90213 18.8035 4.9026 18.1703 5.29342 17.7801L10.5827 12.4986L5.29565 7.20679C4.9053 6.81609 4.90559 6.18292 5.29629 5.79257C5.68699 5.40223 6.32016 5.40251 6.7105 5.79321L11.998 11.0855L17.2739 5.81734C17.6648 5.42711 18.2979 5.42758 18.6881 5.81839C19.0784 6.20921 19.0779 6.84237 18.6871 7.23261L13.4115 12.5003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVisit);
export default __webpack_public_path__ + "static/media/close-visit.b90fc4d5b12343453191e10671e99d81.svg";
export { ForwardRef as ReactComponent };